import Vue from 'vue'

// local state
const getDefaultState = () => {
  return {
    value: {
      show: 'd-none', //show || d-none
      type: '', //warning danger info success
      message: '',
      time: 5000,
    }
  }
}

const state = getDefaultState()

const getters = {}

const mutations = {
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  updateAlert (state, value) {
    state.value = value
  },
  setAlert (state, payload) {
    let time = payload.time || 5000
    state.value = {
      show: 'show', //show || d-none
      type: payload.type, //warning danger info success
      message: payload.message,
      time: time,
    }
  },
}

const actions = {
  resetState ({ commit }) {
    commit('resetState')
  },
  setAlert ({ commit }, payload) {
    commit('setAlert', payload)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
